import AdminSetupTippy from './modules/AdminSetupTippy';
import ColorPicker from './modules/ColorPicker';
import DpitAdminBtnActions from './modules/DpitAdminBtnActions';

jQuery(document).ready(($) => {
	window.$ = $;
	if (window.dp_main_admin_settings_config.dpDebugEn) console.log('Admin Settings config:', window.dp_main_admin_settings_config);
	new AdminSetupTippy(window.dp_main_admin_settings_config);
	new ColorPicker(window.dp_main_admin_settings_config);
	new DpitAdminBtnActions(window.dp_main_admin_settings_config);
});
